import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setStock } from '../actions'
import VehicleDetail from './VehicleDetail'

const mapStateToProps = state => ({
  wizards: state.wizards,
  stock: state.stock,
  configuration: state.configuration
})

const mapDispatchToProps = {
  setWizards,
  setStock
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehicleDetail)
